export default [
    {
        path: '/dossier/:id',
        props: true,
        component: () => import('@/views/Dossier/Show.vue'),
        children: [
            {
                path: '/',
                redirect: {
                    path: 'communicatie'
                },
                props: true,
            },
            {
                path: 'reisvoorstellen',
                component: () => import('@/views/Dossier/Subviews/Proposals.vue'),
                props: true,

            },
            {
                path: 'communicatie',
                component: () => import('@/views/Dossier/Subviews/Communication'),
                props: true,

            },
            {
                path: 'reizigers',
                component: () => import('@/views/Dossier/Subviews/Travellers.vue'),
                props: true,

            },
            {
                path: 'downloads',
                component: () => import('@/views/Dossier/Subviews/Downloads.vue'),
                props: true,
            },
            {
                path: 'facturen',
                component: () => import('@/views/Dossier/Subviews/Invoices.vue'),
                props: true,
            },
            {
                path: 'tijdmanagement',
                component: () => import('@/views/Dossier/Subviews/TimeManagement.vue'),
                props: true,
            },
            {
                path: 'agenten',
                component: () => import('@/views/Dossier/Subviews/Agents.vue'),
                props: true,
            },
        ]
    },
    {
        path: '/dossiers/no-users',
        props: true,
        component: () => import('@/views/Dossier/NoUsers'),
    },
    {
        path: '/dossiers/leads/general',
        props: true,
        component: () => import('@/views/Dossier/Leads'),
    },
    {
        path: '/dossiers/leads/cancelled',
        props: true,
        component: () => import('@/views/Dossier/LeadsCanceled'),
    },
    {
        path: '/dossiers/leads/visual',
        props: true,
        component: () => import('@/views/Dossier/LeadsVisual'),
    },
    {
        path: '/dossiers/check',
        props: true,
        component: () => import('@/views/Dossier/UncheckedAgentProducts.vue'),
    },
    {
        path: '/dossiers/check-agent-attachment-downloads',
        props: true,
        component: () => import('@/views/Dossier/UncheckedAgentAttachmentDownloads.vue'),
    },
    {
        path: '/dossiers/ticket/',
        props: true,
        component: () => import('@/views/Dossier/Ticket/tickets'),
    },
    {
        path: '/dossiers/ticket/flight/classification/',
        props: true,
        component: () => import('@/views/Dossier/Ticket/Flight/Classification/classifications'),
    },
];
